import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';

import Main from './components/Main';
import ConfirmCode from './components/ConfirmCode';
import Print from './components/Print';
import Services from './components/services';
import OfflineTicket from './components/offlineTicket';
import PrintReceipt from './components/printreceipt';
import CustomerForm from './components/CustomerForm';
import CustomerView from './components/customerView';


function App() {
  return (
    <div className="App">
      <Router>
       
        <Routes>
       
          <Route path="/*" element={<MainRoutes />} />
          <Route path="/qr-ticket-generator/*" element={<QRRoutes />} />
          {/* <Route path="/confirm-code" element={<ConfirmCode />} />
          <Route path="/print" element={<Print />} />
          <Route path="/services" element={<Services />} />
          <Route path="/offline-ticket" element={<OfflineTicket />} />
          <Route path='/print-receipt' element={<PrintReceipt/>} />
           */}
        </Routes>
      </Router>
    </div>
  );
}

function MainRoutes() {
  return (
    <Routes>
     <Route path="/" element={<Main />} />
          <Route path="/confirm-code" element={<ConfirmCode />} />
          <Route path="/print" element={<Print />} />
          <Route path="/services" element={<Services />} />
          <Route path="/offline-ticket" element={<OfflineTicket />} />
          <Route path='/print-receipt' element={<PrintReceipt/>} />
          
    </Routes>
  );
}

function QRRoutes() {
  return (
    <Routes>
     <Route path="/" element={<CustomerForm />} />
          <Route path="/customer-form" element={<CustomerForm />} />
          <Route path="/customer-view" element={<CustomerView />} />
          
    </Routes>
  );
}

export default App;
